import { getUiLocale, persistUiLocale } from './locale';
import zhCN from '../../locales/zh-CN.json';
import enUS from '../../locales/en-US.json';
import viVN from '../../locales/vi-VN.json';

const BUNDLED: Record<string, Record<string, string>> = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'vi-VN': viVN,
};

let messages: Record<string, string> = {};

export function getUiMessages() {
  return messages;
}

export function tx(
  t: Record<string, string> | null | undefined,
  key: string,
  fallback: string,
  vars?: Record<string, string | number>
) {
  const fromT = t && t[key];
  let s = fromT || messages[key] || fallback;
  if (vars) {
    Object.keys(vars).forEach((name) => {
      s = s.split('{{' + name + '}}').join(String(vars[name]));
    });
  }
  return s;
}

export async function bootstrapUiMessages(locale?: string) {
  const lang = persistUiLocale(locale || getUiLocale());
  messages = { ...(BUNDLED[lang] || {}) };
  return messages;
}
